export default {
  textColor : 'black',
  borderTopForStore: '0px',
  marginTop: '10px',
  backgroundColor: '#B4CDEC',
  reassuranceLinkMargin: '',
  font: {
    ubi: '"Ubisoft Sans Regular", Arial, sans-serif',
    ubiBold: '"Ubisoft Sans Bold", Arial, sans-serif',
    boldText : '"Ubisoft Sans Bold", Arial, sans-serif',
  },
};
